import React from 'react';
import { twMerge } from 'tailwind-merge';
import type { StatusType } from './status-types/status-types';
import { STATUS_TYPES } from './status-types/status-types';

export type StatusProps = React.HTMLAttributes<HTMLDivElement> & {
  status: StatusType;
};

export const Status: React.FC<StatusProps> = ({ status, className, children, ...props }) => {
  const updatedClassName = twMerge(
    'rounded-2xl px-2.5 py-1.5 text-sm font-medium cursor-pointer',
    STATUS_TYPES[status],
    className,
  );

  return (
    <div className={updatedClassName} {...props}>
      {children}
    </div>
  );
};
